import { Toast } from 'vant';
const app = {
  state: {
    toast:null
  },
  mutations: {
    /**
     * 加载loading
     * @param {}} state 
     */
    showToast(state,text) {
      state.toast=Toast.loading({
        message: text?text:'加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
    },
    /**
     * 关闭loading
     * @param {*} state 
     */
    closeToast(state) {
      state.toast.clear();
    },
    setCompanyList (state, data) {
      state.companyList = data
    }
  },
  actions: {
    
  }
}

export default app
